module.exports = __webpack_public_path__ + "img/CHL.6b5a01ca.svg";